// extracted by mini-css-extract-plugin
export default {"scrollable":"SendGift_scrollable__fbaZO"};